import * as React from 'react'
import Navbar from '../../setup/Navbar'
import { Container, Grid2, IconButton, Tooltip } from '@mui/material'
import ButtonNormal from '../../../BuiltInComponent/ButtonNormal'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import StickyHeadTable from '../../../BuiltInComponent/TableWithPagination'
import Loading from '../../../BuiltInComponent/Loading'
import { getVoucherMasterData } from '../../../features/StockManagement/Purchases/prSlice'
import AssessmentIcon from '@mui/icons-material/Assessment'

export default function PurchaseRequestList() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { masterData, isLoading } = useSelector((state) => state.pr)

    React.useEffect(() => {
        dispatch(getVoucherMasterData())
        // dispatch(getPurchaseDetailData('blank'))
    }, [dispatch])

    const tableColumns = [
        { fieldName: 'prID', cName: 'Invoice No', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'prID', cName: 'P.R. ID', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'entDate', cName: 'Post Date', textAlign: 'left', width: 80, status: 'en', dType: 'date' },
        { fieldName: 'dispName', cName: 'Request By', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'sfDescription', cName: 'Department', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'remarks', cName: 'Remarks', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'prStatus', cName: 'Current Status', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'totalItems', cName: 'Total Items', textAlign: 'right', width: 80, status: 'en', dType: 'number' },
        { fieldName: 'Edit', cName: 'Edit', textAlign: 'center', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'Delete', cName: 'Delete', textAlign: 'center', width: 80, status: 'dis', dType: 'string' },
        { fieldName: 'Delete', cName: 'Delete', textAlign: 'center', width: 80, status: 'dis', dType: 'string' },
    ];

    const onEditClick = async (itemCode) => {
        navigate('/AddPurchaseRequest', { state: { prID: itemCode } })
    }
    const onDeleteClick = async (itemCode) => { }

    const onAddNewClick = () => {

        navigate('/AddPurchaseRequest')

    }

    return (
        <>
            <Navbar />
            <Container>
                <Grid2 container spacing={2} sx={{ marginTop: 2, marginBottom: 2 }}>
                    <Grid2 size={8}>

                    </Grid2>
                    <Grid2 size={3}>
                        <ButtonNormal text='Add New Purchase Request' onClick={onAddNewClick} />
                    </Grid2>
                    <Grid2 size={1} sx={{ textAlign: 'right' }}>
                        <Tooltip title='Current Stock Report'>
                            <IconButton color='primary' size='large' sx={{ p: 1.25 }} onClick={() => navigate('/CurrentStock')}>
                                <AssessmentIcon fontSize='large' />
                            </IconButton>
                        </Tooltip>
                    </Grid2>
                </Grid2>
                {isLoading ? <Loading /> :
                    <StickyHeadTable tableColumns={tableColumns} tableData={masterData && masterData}
                        onEditClick={onEditClick} onDeleteClick={onDeleteClick} />
                }

            </Container>
        </>
    )
}





